export default function CalendarEmpty({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V6H15V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V6H17.5C18.0523 6 18.5 6.44772 18.5 7V18C18.5 18.5523 18.0523 19 17.5 19H6.5C5.94772 19 5.5 18.5523 5.5 18V7C5.5 6.44772 5.94772 6 6.5 6H7V5ZM6.5 10H17.5V18H6.5V10Z"
        fill="currentColor"
      />
    </svg>
  )
}
